/**
 * External dependencies
 */
import React from "react";
import { Box, Text } from "@towersystems/towersystems-design-system";
import Dropdown from "react-dropdown";
import { get } from "lodash";

/**
 * Internal dependencies
 */
import useReportBuilder from "modules/report-builder/use-report-builder";

const ConfigureLimit = () => {
  const { report, editReport } = useReportBuilder();

  const options = [
    { value: "5", label: "Limit 5" },
    { value: "10", label: "Limit 10" },
    { value: "15", label: "Limit 15" },
    { value: "20", label: "Limit 20" },
    { value: "100", label: "Limit 100" },
    { value: "500", label: "Limit 500" },
  ];

  const handleChange = ({ value }) => {
    editReport({ config: { limit: value } });
  };

  return (
    <Box>
      <Text size="xsmall">Amount of data displayed</Text>
      <Dropdown
        value={get(report, "config.limit", "5")}
        onChange={handleChange}
        options={options}
      />
    </Box>
  );
};

export default ConfigureLimit;
